import { cn } from '@/shadcn/lib/utils';

type Props = {
  className?: string;
};

const Footer = ({ className }: Props) => (
  <footer
    className={cn(
      'absolute bottom-0 flex gap-6 px-3 py-[3px] text-[10px] text-foreground',
      className
    )}
  >
    <span>Stratumn © {new Date().getFullYear()}. All rights reserved.</span>
    <span>
      <a
        className="no-underline hover:underline"
        href="/gdpr-privacy-policy"
        rel="noopener noreferrer"
        target="_blank"
      >
        GDPR privacy policy
      </a>
    </span>
  </footer>
);

export default Footer;
